import React, { FC, useState } from 'react';
import ActionButton from '~components/atoms/ActionButton';
import Modal from '~components/atoms/Modal';
import Table from '~components/molecules/Table';
import ViewSerialNoModalModal from '~components/molecules/ViewSerialNoModal';
import combinedActions from '~redux/combinedActions';
import { useAppDispatch, useAppSelector } from '~redux/hooks';
import { MetalTypeEnum, TransactionActionEnum } from '~utils/enums';
import EarmarkModalContent from './EarmarkModal';

type GoldTransactionItemsProps = {
    isOpen: boolean;
    onClose: () => void;
    isLoading: boolean;
    mode: 'view' | 'earmark' | 'edit';
}

const GoldTransactionProductDetailsTable: FC<GoldTransactionItemsProps> = ({ isOpen, onClose, isLoading, mode }) => {
    const dispatch = useAppDispatch();

    const selectedTransaction = useAppSelector((state) => state.gold.buyAndSellGold.selectedTransaction);
    const discountList = useAppSelector((state) => state.setting.discounts.data);

    const [serialNoList, setSerialNoList] = useState<string[]>([]);
    const [isSerialNoModalOpen, setIsSerialNoModalOpen] = useState(false);

    const setIsTransactionDetailsModalOpen = (state: boolean) => dispatch(combinedActions.goldSetIsTransactionDetailsModalOpen(state));

    const tableHeader = [
        'ID',
        'PRODUCT ID',
        'PRODUCT NAME',
        'DESCRIPTION',
        'AMOUNT',
        'PHYSICAL WEIGHT',
        'TOTAL WEIGHT',
        'PRICE',
        'SERIAL NO.',
        'DISCOUNT NAME',
        'DISCOUNT CODE',
        'DISCOUNT TYPE',
        'DISCOUNTED PRICE',
        'NET VALUE PER TRANSACTION ITEM',
        'ACTION',
    ];

    const tableBody = selectedTransaction?.items.map((item) => {

        const {
            customerTransactionItemId,
            productId,
            productName,
            description,
            amount,
            physicalGoldWeight,
            physicalSilverWeight,
            metalType,
            totalWeight,
            goldPrice,
            silverPrice,
            serialNo,
            discountName,
            discountCode,
            discountTransactionType,
            discountedPrice,
            netValuePerTransactionItem,
        } = item;

        const physicalWeight =
            selectedTransaction?.metalType === MetalTypeEnum.Gold
                ? physicalGoldWeight
                : physicalSilverWeight;

        const price =
            selectedTransaction?.metalType === MetalTypeEnum.Gold
                ? goldPrice
                : silverPrice;

        // const getDiscountName = () => {
        //     const selectedDiscount = discountList.find(discount => discount.discountId === discountId);

        //     if (!selectedDiscount) return '-';

        //     return selectedDiscount;
        // };

        const handleViewSerialNo = () => {
            setIsSerialNoModalOpen(true);
            setSerialNoList(serialNo);
        };

        const renderSerialNo = () => {
            return (
                <ActionButton
                    testId='transaction-details-product-view-serialNo-modal'
                    key={customerTransactionItemId}
                    label='View'
                    onClick={() => handleViewSerialNo()}
                />
            );
        };

        const renderActionButton = () => {
            return (
                <ActionButton
                    testId='transaction-product-details-view-receipt-button'
                    label='View Receipt'
                    onClick={() => setIsTransactionDetailsModalOpen(true)}
                />
            );
        };

        const getDiscountType = (discountType: TransactionActionEnum) => {
            if (discountType === TransactionActionEnum['Bank Sell']) {
                return (
                    <div>
                        <p>Discount</p>
                        <p>(Bank Sell)</p>
                    </div>
                );
            }

            if (discountType === TransactionActionEnum['Bank Buy']) {
                return (
                    <div>
                        <p>Markup</p>
                        <p>(Bank Buy)</p>
                    </div>
                );
            }
        };

        return [
            customerTransactionItemId,
            productId,
            productName,
            description,
            amount,
            physicalWeight ?? 'N/A',
            totalWeight,
            (Math.round(Number(price) * 100) / 100).toFixed(2),
            renderSerialNo(),
            discountName || '-',
            discountCode || '-',
            discountTransactionType ? getDiscountType(discountTransactionType) : '-',
            discountedPrice || '-',
            netValuePerTransactionItem ? `RM${(Math.round(Number(netValuePerTransactionItem) * 100) / 100).toFixed(2)}` : '-',
            renderActionButton(),
        ];
    }) || [];

    const getTitle = () => {
        switch (mode) {
            case 'view': return 'Transaction Product List';
            case 'earmark': return 'Convert Transaction to Earmark';
            case 'edit': return 'Edit Earmark Details';
            default: return '';
        }
    };

    return (
        <Modal
            testId='transaction-product-details-modal-close'
            isOpen={isOpen}
            onClose={onClose}
            title={getTitle()}
        >
            {mode === 'view' ? (
                <Table
                    header={tableHeader}
                    body={tableBody}
                    isLoading={isLoading}
                />
            ) : mode === 'earmark' ? (
                <EarmarkModalContent transaction={selectedTransaction} onClose={onClose} />
            ) : (
                <EarmarkModalContent transaction={selectedTransaction} onClose={onClose} mode='edit' />
            )}

            <ViewSerialNoModalModal
                isOpen={isSerialNoModalOpen}
                onClose={() => setIsSerialNoModalOpen(false)}
                serialNo={serialNoList}
            />
        </Modal>
    );
};

export default GoldTransactionProductDetailsTable;
